const templateDetailColumns = [
	// { field: 'templateName', header: 'Template Name' },
	// { field: 'templateDescription', header: 'Template Description' },
	{ field: 'consentMode', header: 'Consent Mode' },
	//consentTypes
	//fiTypes
	{ field: 'Purpose.text', header: 'Purpose' },
	{ field: 'fetchType', header: 'Fetch Type' },
	//Frequency
	//DataLife
	//DataFilter(optional)
	//ConsentExpiry
	{ field: 'consentStart.value', header: 'Consent Start Days' },
	{ field: 'dataRangeStart.value', header: 'Data Range Start Month' },
	{ field: 'dataRangeEnd.value', header: 'Data Range End Month' },
	// { field: 'createdBy', header: 'Created By' },
	{ field: 'updatedBy', header: 'Updated By' },
	{ field: 'approvedBy', header: 'Approved By' },
	//Creation Date
	//Updation Date
	//Approved Date
];

export default templateDetailColumns;
